import { RotatingSubtitle } from './components/RotatingSubtitle/RotatingSubtitle';
import styles from './Hero.module.css';

export function Hero({ title, messages }: { title: string; messages: string[] }) {
  return (
    <section className={styles.hero}>
      <h1 className={styles.title}>{title}</h1>
      <RotatingSubtitle messages={messages} />
    </section>
  );
}
